<div class="dark-theme wfmload">
    <div style="display: inline-block">
  <div class="spinner"><wfm-spinner></wfm-spinner></div>
    <div class="text-align--center" style="font-size: 20px; font-weight: bold;">{{ 'sso.wfm.home.signin.msg' | translate }}</div>
    </div>
</div>
